import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromResource from '../+state/resource.reducer';
import * as actions from '../+state/resource.actions';
import { Observable } from 'rxjs';
import { EntityServices } from 'ngrx-data';
import { ChassisEntityCollectionServiceBase, ChassisEntityCollectionServiceFactory } from '../services/chassis-entity-collection-service-base';
import { IAbstractEntity } from '../interfaces';
import { take } from 'rxjs/operators';
import * as pluralize from 'pluralize';

@Injectable({
    providedIn: 'root'
})
export class ResourceService {

    public resources$: Observable<fromResource.Resource[]>;
    public resources = [];

    constructor(protected store: Store<fromResource.State>, protected entityServices: EntityServices, protected serviceFactory: ChassisEntityCollectionServiceFactory, protected injector: Injector) {
        this.resources$ = this.all();
    }

    public all() {
        return this.store.select(fromResource.selectAll);
    }

    public register(name: string, label: string, options: ResourceOptions = {}) {
        this.store.dispatch(new actions.Create({
            id: name,
            label: label,
            options
        }));
    }

    public get<T extends IAbstractEntity = IAbstractEntity>(resourceId): ChassisEntityCollectionServiceBase<T> {
        return this.serviceFactory.create<T>(resourceId);
    }

    /**
     * Extract the resource from the url and return the proper collection service
     *
     * @param url
     */
    public getResourceFromUrl<T extends IAbstractEntity = IAbstractEntity>(url: string): Observable<ChassisEntityCollectionServiceBase<T>> {
        return new Observable((observer => {
            this.resources$.pipe(take(1)).subscribe(resources => {
                const uri_segments = url.split('/').reverse();

                const resourceName = uri_segments.find((segment: string) => {
                    return resources.filter(resource => pluralize.plural(resource.id) === segment).length > 0;
                });

                if (resourceName) {
                    observer.next(this.get(pluralize.singular(resourceName)));
                } else {
                    observer.error('Could not find resource for current url');
                }

                observer.complete();
            });
        }));
    }
}

export interface ResourceOptions {
    icon?: string;
    model?: object;
    service?: object;
}

//
// const resourceService = new ResourceService();
//
// // retrieve all
// resourceService
//     .of('users')
//     .all();
//
// // retrieve with pagination
// resourceService
//     .of('users')
//     .paginate(10)
//     .get();
//
// // build query
// resourceService
//     .of('users')
//     .where('name', '==', 'Admin')
//     .where('role', 'admin')
//     .get();
//
// // retrieve one
// resourceService
//     .of('users')
//     .find(10);



// WEBPACK FOOTER //
// ./libs/chassis-resource/src/services/resource.service.ts